<template>
  <el-dialog :visible="visible" width="30%" title="订单退款(选择退款类型)"
    @before-close="close">
    <el-select v-model="refundType" style="width: 100%; margin-bottom: 10px">
      <el-option :value="0" label="仅退款">
        仅退款
      </el-option>
      <el-option :value="1" label="退货退款">
        退货退款
      </el-option>
      <el-option :value="2" label="部分退货退款">
        部分退货退款
      </el-option>
    </el-select>
    <el-input placeholder="退款理由" v-model="reason"></el-input>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" @click="confirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    name: 'orderRefund',
    data() {
      return {
        visible: false,
        refundType: 0,
        reason: '',
        fun: null,
      }
    },
    methods: {
      open(fun) {
        this.visible = true;
        this.refundType = 0;
        this.reason = '';
        this.fun = fun;
      },
      confirm() {
        this.fun(this.refundType, this.reason);
        this.close();
      },
      close() {
        this.visible = false;
      },
    }
  }
</script>

<style lang="scss" scoped>

</style>